import React from 'react';

import { useSelector } from 'react-redux';

import { RibbonBar, RibbonDivider } from 'common/components';
import OpenSection from './components/sections/reporting/grid/OpenSection';
import DeleteReportSection from './components/sections/reporting/grid/DeleteReportSection';

import Addition from './components/sections/home-grid/AdditionSection';
import ShareSection from './components/sections/shared/ShareSection';
import ManageSharingSection from './components/sections/shared/ManageSharingSection';
import DetailSection from './components/sections/home-grid/DetailSection';
import { ViewLayout, AdvanceStack } from './components';
import gridSelectors from 'common/components/grid-view/controllers/selectors';
import BackControl from './components/controls/home/Back';

import * as ribbonSelectors from '@redux/ribbon/selectors';

import { Can } from 'context/Can';
import { ABILITY_ACTION, ABILITY_SUBJECT } from 'static/Permission';
import OpenSchedule from './components/controls/advanced-search/OpenSchedule';
import { ADVANCED_FILTER_MODE } from 'pages/reporting/utils/constants';

// const productsForMember = 'products/member';
// const assetsForMember = 'assets/member';

const Reportings = () => {
  // const pathname = window.location.pathname;
  const selectedItemList = useSelector(
    gridSelectors.makeSelectDetailCurrentITemsSelection()
  );
  const closeDetailStack = useSelector(
    ribbonSelectors.selectCloseDetailStack()
  );

  // const isBackToMemberProfile =
  //   pathname.includes(productsForMember) || pathname.includes(assetsForMember);
  // const isReportingsBack = pathname.includes('/reporting');

  const isDisabledCloseDetail =
    window.location.search !== '?query=1' ||
    closeDetailStack?.name !== 'query' ||
    closeDetailStack?.stack.length < 2;

  const showScheduleDownload = selectedItemList?.length === 1;
  const [firstItems] = selectedItemList;
  const modeData = firstItems?.isBasicMode
    ? ADVANCED_FILTER_MODE.FLAT_DATA
    : ADVANCED_FILTER_MODE.NESTED_DATA;

  return (
    <RibbonBar>
      <ManageSharingSection />
      <Can I={ABILITY_ACTION.VIEW} a={ABILITY_SUBJECT.REPORTING}>
        <DetailSection />
      </Can>
      <Can I={ABILITY_ACTION.VIEW} a={ABILITY_SUBJECT.REPORTING}>
        <ViewLayout />
      </Can>

      <RibbonDivider />
      <Addition
        selectedItemList={selectedItemList}
        disabledFavorite={true}
        type='reporting'
      />
      <ShareSection selectedItemList={selectedItemList} />
      <RibbonDivider />
      <OpenSection selectedItemList={selectedItemList} />
      <OpenSchedule
        modeData={modeData}
        reportId={firstItems?.id}
        showScheduleDownload={showScheduleDownload}
      />
      <RibbonDivider />
      <DeleteReportSection />
      <Can I={ABILITY_ACTION.VIEW} a={ABILITY_SUBJECT.REPORTING}>
        <AdvanceStack isNested selectedItemList={selectedItemList} />
      </Can>
      <BackControl
        ribbonSide='right'
        isDisabled={isDisabledCloseDetail}
        // isBackToMemberProfile={isBackToMemberProfile}
        // isReportingsBack={isReportingsBack}
      />
    </RibbonBar>
  );
};

export default Reportings;
